/* eslint-disable no-invalid-this */

function replace(str, regex, replacement, _options) {
  const options = typeof _options === "string" ? _options : "g";
  return str.replace(new RegExp(regex, options), replacement);
}

export default replace;
